import styled from "styled-components";
import { ReactComponent as HamburgerIcon } from "assets/icons/menu.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

import { Flex } from "Element/Flex";
import { PrimaryButton, SecondaryButton, WrongNetwork } from "Element/Button";

export const StyledHeaderWrapper = styled.div<{ isOpen?: boolean }>`
  width: 100%;

  padding: 20px 120px;
  background-color: ${({ theme }) => theme.colors.neutral00};
  transition: all 0.15s ease-in-out;
  z-index: 10;
  ${({ theme, isOpen }) => theme.mediaWidth.upToMedium`
    padding-top: 20px;
    padding-left: 24px;
    padding-bottom: 20px;
    padding-right: 24px;
    align-items: center;
  `}
`;
export const HeaderContentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
`;
export const StyledHeaderBrand = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  ${({ theme }) => theme.mediaWidth.upToMedium`
      justify-content: space-between;
      // width: 100%;
  `}
`;

export const StyledNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  margin-right: 80px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `}
`;

export const MenuWrapper = styled.nav<{ isOpen: boolean }>`
  display: flex;
  position: fixed;
  flex-direction: column;
  padding: 0 24px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.neutral00};
  z-index: 5;
  margin-top: 79px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`;

export const MenuIcon = styled(HamburgerIcon)`
  cursor: pointer;
  display: none;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;
  `}
`;

export const CloseBtn = styled(CloseIcon)`
  cursor: pointer;
  display: none;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;
  `}
`;

export const StyledNavItem = styled.a`
  position: relative;
  :not(:last-child) {
    margin-right: 48px;
  }
  :hover {
    ::after {
      transform: scaleX(1);
      transform-origin: bottom left;
    }
  }
  ::after {
    content: "";
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 2px;
    bottom: 7px;
    left: 0;
    background-color: ${({ theme }) => theme.colors.purple};
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
      font-size: 46px;
      font-weight: 700;
      text-align: center;
      :not(:last-child) {
        margin-bottom: 24px;
        margin-right: 0;
      }
      ::after{
        height: 3px;
        bottom: 17px;
      }
  `}
`;

export const ConnectedStatus = styled(SecondaryButton)`
  margin-right: 24px;
  max-width: 156px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 12px;
  `}
`;

export const MenuItemWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  margin-top: 64px;
`;

export const StyledConnectButton = styled(PrimaryButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content !important;
  height: 100%;
  margin-right: 24px;

  text-transform: uppercase;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
    margin: 0 12px;
  `}
`;

export const StyledWrongNetwork = styled(WrongNetwork)`
  margin-right: 24px;
  width: fit-content !important;
  text-transform: uppercase;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 12px;
  `}
`;
